import { defineMessages } from 'react-intl';
import { insertInArray } from '@plone/volto/helpers/Utils/Utils';

const messages = defineMessages({
  Description: {
    id: 'Description',
    defaultMessage: 'Description',
  },
  Caption: {
    id: 'Caption',
    defaultMessage: 'Caption',
  },
  AltDescr: {
    id: 'AltDescr',
    defaultMessage:
      'This text comes from the alt description field at the Image',
  },
  Title: {
    id: 'Title',
    defaultMessage: 'Title',
  },
  BlockWidth: {
    id: 'Block Width',
    defaultMessage: 'Block Width',
  },
});

export const imageBlockSchemaEnhancerSAW = ({ formData, schema, intl }) => {
  if (formData.url) {
    schema.fieldsets[0].fields = insertInArray(
      schema.fieldsets[0].fields,
      'description',
      1,
    );
    // schema.fieldsets[0].fields = insertInArray(
    //   schema.fieldsets[0].fields,
    //   'title',
    //   1,
    // );

    schema.properties.description = {
      title: intl.formatMessage(messages.Caption),
      widget: 'textarea',
    };
    schema.properties.alt = {
      ...schema.properties.alt,
      description: intl.formatMessage(messages.AltDescr),
      isDisabled: true,
    };
    // schema.properties.title = {
    //   title: intl.formatMessage(messages.Title),
    // };
  }

  return schema;
};
